// import React, { useState } from 'react'
// import {BsCloudUpload}from 'react-icons/bs'
// import {ImagetoBase64} from '../utility/Imagetobase64'
// import {toast} from 'react-hot-toast'



// const NewProduct= ()=> {
//   const [data, setData]= useState({
//     name: '',
//     category: '',
//     image: '',
//     price: '',
//     description: '',
//   })

//   const handleOnChange= (e)=> {
//     const {name, value} = e.target
//     setData((preve)=>{
//       return{
//         ...preve,
//         [name]: value
//       }
//     })
//   }

//   const uploadImage= async(e)=>{
//     const data = await ImagetoBase64(e.target.files[0])

//     setData((preve)=>{
//       return{
//         ...preve,
//         image: data,
//       }
//     })
//   }

//   const handleSubmit=async(e)=>{
//     e.preventDefault()


//     const {name, image, category, price}= data
//     if(name && image && category && price){
//       const fetchData= await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/uploadProduct`, {
//         method: "POST",
//         headers: {
//           "content-type": "application/json"
//         },
//         body: JSON.stringify(data)
//       })
  
//       const fetchRes= await fetchData.json()
//       toast(fetchRes.message)
//       setData(()=>{
//         return{
//           name: '',
//           category: '',
//           image: '',
//           price: '',
//           description: '',
//         }
//       })
//     }
//     else{
//       toast("Please fill all the fields")
//     }
//   }
  

//   return (
//     <div className='p-4'>
//       <form className='m-auto w-full max-w-md shadow flex flex-col p-3 bg-white' onSubmit={handleSubmit}>
//         <label htmlFor= "name">Name</label>
//         <input type= {"text"} name= "name" className='bg-slate-200 p-1 my-1' onChange={handleOnChange} value= {data.name}/>


//         <label htmlFor= "category">Category</label>
//         <select className='bg-slate-200 p-1 my-1' id='category' name= 'category' onChange={handleOnChange} value= {data.category}>
// {/* Change it to requirements of the site: Sockets and all */}
//           <option value={"other"}>Select Category</option>
//           <option value={"Switches"}>Switches</option>
//           <option value={"Sockets"}>Sockets</option>
//           <option value={"Regulators"}>Regulators</option>
//           <option value={"Indicators"}>Indicators</option>
//           <option value={"Holders"}>Holders</option>
//           <option value={"Plates"}>Plates</option>
//           <option value={"MCB"}>MCB</option>
//           <option value={"MCBBoxes"}>MCB Boxes</option>
//           <option value={"SSCombine"}>SS Combine</option>
//           <option value={"Plugs"}>Plugs </option>
//           <option value={"Gl MOdular Box"}>Gl Modular Box</option>
//           <option value={"OthersItems"}>Others </option>
//         </select>

        
//         <label htmlFor='image'>Image
//           <div className='h-40 w-full bg-slate-200 rounded flex items-center justify-center cursor-pointer'>
//             {
//               data.image? <img src= {data.image} alt="itemImage" className='h-full w-full'/> : <span className='text-5xl'><BsCloudUpload/></span>
//             }

//             <input type= {"file"} accept= "image/" id="image" onChange={uploadImage} className= "hidden"/>
//           </div>
//         </label>



//         <label htmlFor='price' className='my-1'>Price</label>
//         <input type= {"text"} className='bg-slate-200 p-1 my-1' name= 'price' onChange={handleOnChange} value={data.price}/>

//         <label htmlFor='description'>Description</label>
//         <textarea row= {2} value= {data.description} className='bg-slate-200 p-1 my-1 resize-none' name='description' onChange={handleOnChange}></textarea>

//         <button className='bg-red-500 hover:bg-red-600 text-white text-lg font-medium my-2 drop-shadow'>Save</button>

//       </form>
//     </div>
//   )
// }

// export default NewProduct;



import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { ImagetoBase64 } from '../utility/Imagetobase64';
import { BsCloudUploadFill, BsLightningChargeFill } from 'react-icons/bs';
import { MdOutlineInventory2 } from 'react-icons/md';

const CATEGORIES = [
  'Switches','Sockets','Regulators','Indicators','Holders','Plates',
  'MCB','MCBBoxes','SSCombine','Plugs','Gl MOdular Box','OthersItems',
];

const EMPTY = { name: '', category: '', image: '', price: '', description: '' };

export default function NewProduct() {
  const [data, setData]       = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handle = (e) =>
    setData(p => ({ ...p, [e.target.name]: e.target.value }));

  const processImage = async (file) => {
    if (!file) return;
    const b64 = await ImagetoBase64(file);
    setData(p => ({ ...p, image: b64 }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.image || !data.category || !data.price) {
      toast.error('Fill in all required fields'); return;
    }
    setLoading(true);
    try {
      const res  = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/uploadProduct`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(data),
      });
      const json = await res.json();
      toast.success(json.message);
      setData(EMPTY);
    } catch { toast.error('Upload failed'); }
    finally   { setLoading(false); }
  };

  return (
    <div
      className="min-h-screen py-10 px-4 flex items-start justify-center relative"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Blob */}
      <div className="pointer-events-none absolute"
           style={{ top: '5%', left: '50%', transform: 'translateX(-50%)',
             width: 600, height: 300,
             background: 'radial-gradient(ellipse, rgba(99,102,241,0.07) 0%, transparent 70%)',
             filter: 'blur(60px)' }} />

      <div className="w-full max-w-lg animate-fade-up">
        <div className="flex items-center gap-3 mb-6">
          <MdOutlineInventory2 className="text-2xl" style={{ color: 'var(--indigo-light)' }} />
          <div>
            <p className="section-eyebrow mb-0.5">Admin Panel</p>
            <h1 className="font-display text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
              NEW PRODUCT
            </h1>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="glass-hi rounded-2xl overflow-hidden"
          style={{ border: '1px solid var(--glass-border)' }}
        >
          <div style={{ height: 3, background: 'var(--grad-brand)' }} />

          <div className="p-8 flex flex-col gap-5">

            {/* Name */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Product Name *
              </label>
              <input
                type="text" name="name" placeholder="e.g. 16A SP Switch"
                className="input-glass py-3 px-4 rounded-xl"
                value={data.name} onChange={handle}
              />
            </div>

            {/* Category */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Category *
              </label>
              <select
                name="category"
                className="input-glass py-3 px-4 rounded-xl cursor-pointer"
                value={data.category} onChange={handle}
              >
                <option value="">Select category…</option>
                {CATEGORIES.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            {/* Image upload */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Product Image *
              </label>
              <label
                htmlFor="imgInput"
                className={`
                  block cursor-pointer rounded-xl border-2 border-dashed
                  transition-all duration-200
                  ${dragOver
                    ? 'border-[var(--indigo)] bg-[var(--indigo-dim)]'
                    : 'border-[var(--glass-border)] hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]'
                  }
                `}
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={e => { e.preventDefault(); setDragOver(false); processImage(e.dataTransfer.files[0]); }}
              >
                <div
                  className="flex flex-col items-center justify-center overflow-hidden rounded-xl"
                  style={{ height: 180 }}
                >
                  {data.image ? (
                    <img
                      src={data.image}
                      alt="preview"
                      className="w-full h-full object-contain p-4"
                    />
                  ) : (
                    <div className="text-center px-4">
                      <BsCloudUploadFill
                        className="text-4xl mx-auto mb-2"
                        style={{ color: 'var(--text-muted)' }}
                      />
                      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
                        Click or drag & drop to upload
                      </p>
                      <p className="text-xs font-mono mt-1" style={{ color: 'var(--text-faint)' }}>
                        JPG, PNG, WEBP
                      </p>
                    </div>
                  )}
                </div>
                <input
                  id="imgInput"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={e => processImage(e.target.files[0])}
                />
              </label>
            </div>

            {/* Price */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Price (₹) *
              </label>
              <input
                type="text" name="price" placeholder="e.g. 249"
                className="input-glass py-3 px-4 rounded-xl"
                value={data.price} onChange={handle}
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Description
              </label>
              <textarea
                name="description" rows={3}
                placeholder="Short product description…"
                className="input-glass py-3 px-4 rounded-xl resize-none"
                value={data.description} onChange={handle}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary py-3.5 rounded-xl flex items-center justify-center gap-2"
            >
              {loading ? (
                <span
                  className="w-4 h-4 rounded-full border-2 animate-spin"
                  style={{ borderColor: 'rgba(0,0,0,0.2)', borderTopColor: '#000' }}
                />
              ) : (
                <><BsLightningChargeFill /> Upload Product</>
              )}
            </button>

          </div>
        </form>
      </div>
    </div>
  );
}